import React from "react";

interface IDrawerOptions {
  content: (() => React.ReactNode) | React.ReactNode;
}

interface IDrawerContext {
  showDrawer: (options: IDrawerOptions) => void;
  closeDrawer: () => void;
  isOpen: boolean;
}

const DrawerContext = React.createContext<IDrawerContext | undefined>(undefined);

export { DrawerContext, type IDrawerContext, type IDrawerOptions };
